import React from 'react'
import classNames from 'classnames'

import styles from './DashboardMobileMenu.module.scss'

const DashboardMobileMenu = ({
  activeIndex,
  mobileTabsHandler,
  calendarCount = 0,
  inline = false,
}) => {
  const menuList = [{ title: 'Talks' }, { title: 'Calendar', counter: calendarCount }]
  return (
    <div
      className={classNames(styles.DashboardMobileMenu, {
        [styles.DashboardMobileMenuInline]: inline,
      })}
    >
      <div className={styles.DashboardMobileMenuList}>
        {menuList &&
          menuList.map(({ title, counter }, index) => {
            const isSingleDigitCounter = Number.isFinite(counter) && counter < 10
            return (
              <div
                onClick={() => mobileTabsHandler(index)}
                className={classNames(styles.DashboardMobileMenuItem, {
                  [styles.DashboardMobileMenuItemActive]: index === activeIndex,
                })}
                key={index}
              >
                <div className={styles.DashboardMobileMenuItemTitle}>{title}</div>
                {counter > 0 && (
                  <div
                    className={classNames(styles.DashboardMobileMenuItemCounter, {
                      [styles.DashboardMobileMenuItemCounterCircle]: isSingleDigitCounter,
                    })}
                  >
                    {counter}
                  </div>
                )}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default DashboardMobileMenu
